import React, { useEffect, useState } from "react";

import SlidingPanel from "react-sliding-side-panel";
import styled from "styled-components";

import "react-sliding-side-panel/lib/index.css";
import { CrossIconLight } from "../icons/Cross";

import useWindowSize from "~/hooks/useWindowSize";

const MainContainer = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
`;

const PanelContainer = styled.section`
  height: 100%;
  background: white;
`;

const LeftIcons = styled.div`
  min-width: 32px;
  padding: 16px 0px;
  height: 100%;
  background: #f8f8f8;
  border-right: 1px solid #e9e9e9;
`;

const CloseIconContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  cursor: pointer;
`;

type SidePanelProps = {
  type?: "right" | "left" | "top" | "bottom";
  isOpen: boolean;
  children: React.ReactNode;
  onClose: () => void;
  backdropClicked: () => void;
};

export default function SidePanel({ isOpen, type = "right", children, onClose, backdropClicked }: SidePanelProps) {
  const size = useWindowSize();

  const [sidePanelWidthPercentage, setSidePanelWidthPercentage] = useState<number>(30);

  useEffect(() => {
    if (!size) {
      return;
    }

    const _sidePanelContentWidth = document.getElementById("side-panel-content-container")?.offsetWidth;
    const _leftIconsWidth = document.getElementById("left-icons")?.offsetWidth;

    if (_sidePanelContentWidth && _leftIconsWidth) {
      // we need to calculate the size % as a sum of PanelContainer + LeftIcons
      setSidePanelWidthPercentage((100 * (_sidePanelContentWidth + _leftIconsWidth)) / size.width);
    }
  }, [size, isOpen]);

  return (
    <SlidingPanel type={type} isOpen={isOpen} size={sidePanelWidthPercentage} backdropClicked={backdropClicked}>
      <MainContainer>
        <LeftIcons id={"left-icons"}>
          <CloseIconContainer onClick={onClose}>
            <CrossIconLight />
          </CloseIconContainer>
        </LeftIcons>
        <PanelContainer id={"side-panel-content-container"}>{children}</PanelContainer>
      </MainContainer>
    </SlidingPanel>
  );
}
